import _ from 'lodash';

export function createUrl(url: string, queryParams: { [key: string]: string; } = {}): string {
	if (_.isEmpty(queryParams)) {
		return url;
	}

	const [ firstParamKey, ...otherParamsKeys ] = Object.keys(queryParams);
	let newUrl = url + '?' + firstParamKey + '=' + queryParams[firstParamKey];

	otherParamsKeys.forEach((key) => {
		newUrl += '&' + key + '=' + queryParams[key];
	});

	return newUrl;
}
